import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../../services/operations/authApi';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

const LogInForm = ({ setConfirmationModal }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();

    const [showPassword, setShowPassword] = useState(false);
    const onSubmitHandler = (event) => {
        const email = event.email.toLowerCase();
        dispatch(login(email, event.password, navigate, setConfirmationModal));
    }

    return (
        <div>
            <div>
                <form className='w-full flex flex-col md:gap-y-4 gap-y-8 mt-6' onSubmit={handleSubmit(onSubmitHandler)}>
                    <label className='w-full'>
                        <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Email Address <sup className='text-pink-200'>*</sup></p>
                        <input
                            className='p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            type='email'
                            name='email'
                            placeholder='Enter email address'
                            {...register('email', { required: true })}
                        />
                        {errors.email && (
                            <span className='text-pink-500 text-sm'>Please enter your Email</span>
                        )}
                    </label>
                    <label className='relative'>
                        <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Password <sup className='text-pink-200'>*</sup></p>
                        <input
                            className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 pr-12 outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            type={showPassword ? 'text' : 'password'}
                            name='password'
                            placeholder='Enter Password'
                            {...register('password', { required: true })}
                        />
                        {errors.password && (
                            <span className='text-pink-500 text-sm'>Please enter your Password</span>
                        )}
                        <span className='absolute right-3 top-[38px] z-[10] cursor-pointer text-2xl text-richblack-100' onClick={() => showPassword ? setShowPassword(false) : setShowPassword(true)}>
                            {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                        </span>
                        <div className='w-full text-right'>
                            <Link to={'/forgot-password'}><span className='text-xs mt-1 text-blue-100'>Forgot Password</span></Link>
                        </div>
                    </label>
                    <button type='submit' className='bg-yellow-50 py-[8px] px-[12px] hover:scale-95 transition-all duration-200 rounded-[8px] mt-6 font-medium text-richblack-900'>Sign in</button>
                </form>
            </div>
        </div>
    )
}

export default LogInForm;